import { render } from "./LeasesList.vue?vue&type=template&id=a4d361f0"
import script from "./LeasesList.vue?vue&type=script&lang=js"
export * from "./LeasesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__